import {
  answerForField,
  buildStyledXlsx,
  cleanTitle,
  evidenceForField,
  parseFields,
  propertyLabel,
  walkSurveyField,
} from "./helpers";
import type { AttributeRow, PropertyRow } from "./types";

export function buildSurveyAttributesXlsx(attributeRows: AttributeRow[], properties: PropertyRow[]): ArrayBuffer {
  const attributeMap = new Map(attributeRows.map((row) => [row.property_id, row]));
  const rows: string[][] = [[
    "Property",
    "Property ID",
    "Store #",
    "Category",
    "Question",
    "Answer",
    "Evidence",
  ]];

  for (const property of properties) {
    const attr = attributeMap.get(property.id);
    const label = propertyLabel(property);
    if (!attr?.data) {
      rows.push([label, property.id, property.store_number ?? "", "", "", "", ""]);
      continue;
    }

    const fields = parseFields(attr.data);
    for (const field of fields) {
      walkSurveyField(field, "", (leaf, category) => {
        rows.push([
          label,
          property.id,
          property.store_number ?? "",
          category,
          cleanTitle(leaf.title),
          answerForField(leaf),
          evidenceForField(leaf).join("; "),
        ]);
      });
    }
  }

  return buildStyledXlsx(rows, "Survey Attributes", [24, 36, 12, 24, 44, 44, 72]);
}
